export const CAPTCHA_SITE_KEY="6LfmGuUpAAAAAAqD8trwnCVthr5k1KNtBLUJybZY";
export const API_ADDRESS = "https://api-site.azure-api.net/sendmessage";
